<div class="width-1100">

  <mat-card>

    <mat-toolbar class="toolbar-top">

      <div class='title' style='padding: 10px;'>
        CAEX - Toten
      </div>

      <button mat-button (click)='goBack()'>
        <mat-icon>arrow_back</mat-icon>
      </button>

    </mat-toolbar>

  </mat-card>

  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !spinner}" color='warn' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <mat-card style="width: 500px;">

    <div>
      <div>
        <b>{{_caexService.currentMember.name.trim().toUpperCase()}}</b>
      </div>
      <div>
        <!--{{_caexService.currentMember.subCategory.name.trim()}}-->
        {{ _caexService.currentCategory.name }}
      </div>
      <hr>
      <div *ngFor="let order of _caexService.memberOrders">
        <div>{{order.product_name}}</div>
      </div>
      <hr>
    </div>

    <div style="display: flex; flex-direction:row; justify-content: flex-end; padding-right: 30px;">
      <button mat-button matTooltip="Imprimir crachá" style='background-color: whitesmoke;'>
        <mat-icon class='icon-add' style='font-size:1.5em;'>
          print
        </mat-icon>
      </button>
    </div>

  </mat-card>

  <mat-card style="width: 500px;" *ngIf='_authService.isAdmin'>

    <h4>
      Registrar Presença
    </h4>

    <!-- TABLE -->
    <mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.product_name }}
        </mat-cell>
      </ng-container>

      <!-- Register Column -->
      <ng-container matColumnDef="register">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button matTooltip="Registrar presença" (click)='registerPresenceDialog(element, true)'
            style='background-color: whitesmoke;'>
            <mat-icon class='icon-done' style='font-size:1.5em;'>
              check_circle
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row  -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <!-- END TABLE -->

  </mat-card>


</div>